import React, { useState, useEffect } from "react";
import PageLayout from "../../../Layouts/PageLayout/PageLayout";
import Table from "../../../components/common/Table/Table";
import { getApiInstance } from "../../../utils/api";
import { mapList } from "../../../utils/utils";
import { useZone } from "../../../context/ZoneContext";
import { useTranslation } from 'react-i18next'

export default function Comunidades({ user }) {
  const [comunidades, setComunidades] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [paises, setPaises] = useState([]);
  const { selectedZone } = useZone();
  const {t} = useTranslation();

  const columnasComunidades = [
          {
            key: "id",
            label: t('fields.community'),
            sortable: true,
            visible: false,
          },
          { key: "codComunidad", label: t('fields.community'), visible: false },
          {
            key: "comunidad",
            label: t('fields.community'),
            sortable: true,
            visible: true,
          },
          {
            key: "pais",
            label: t('fields.country'),
            sortable: true,
            visible: true,
          },
          { key: "codPais", label: t('fields.country'), visible: false },
        ]

const filterFields = [
  { key: "comunidad", label: t('fields.community'), type: "multiselect" },
  { key: "pais", label: t('fields.country'), type: "multiselect" },
];

    useEffect(() => {
        fetchPaises();
        fetchComunidades();
    }, [selectedZone]);

    const fetchComunidades = async () => {
        setLoading(true);
        const api = getApiInstance();

        try {
            let comunidadesData = [];

            const response = await api.get(
                `/api/Comunidades/GetComunidadesByZona/${selectedZone.value}`
            );
            comunidadesData = response.data;

            const mappings = [
                {
                    fieldToMatch: "codPais",
                    fieldToAdd: "pais",
                    referenceList: paises,
                    referenceKey: "id",
                    referenceValue: "value",
                },
            ];

            setComunidades(comunidadesData);

            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar las comunidades. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

    const fetchPaises = async () => {
        setLoading(true);
        const api = getApiInstance();

        try {
            let paisesData = [];

            const response = await api.get(
                `/api/Paises/GetPaisesByZona/${selectedZone.value}`
            );
            paisesData = response.data;

            setPaises([...mapList(paisesData, "pais", "codPais", "codPais")]);

            setError(null);
        } catch (err) {
            setError(
                "No se han podido cargar los países. Vuelve a intentarlo más tarde."
            );
            console.error(err);
        } finally {
            setLoading(false);
        }
    };

  console.log(user)

  return (
    <PageLayout
      title={t('communities.title')}
      subtitle={t('communities.subtitle')}
    >
      <Table
        columns={columnasComunidades}
        dataTable={comunidades}
        showCheckboxes={true}
        actions={["Eliminar", "Editar"]}
        noResultsMessage={t('communities.noCommunitiesFound')}
        searchTerms={[t('communities.community'), t('communities.country')]}
        formElements={[
          {
            elements: [
              {
                name: "comunidad",
                type: "text",
                label: t('fields.name'),
                placeholder: t('placeholders.enterName'),
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
              {
                name: "codPais",
                type: "select",
                label: t('fields.country'),
                placeholder: t('placeholders.enterCountry'),
                options: paises,
                required: true,
                disabled: false,
                labelVisible: true,
                visible: true,
              },
            ],
          },
        ]}
        loading={loading}
        filterFields={filterFields}
        elementName={t('fields.community')}
        keyProp="codComunidad"
        sortProp="comunidad"
        addApiUrl="/api/Comunidades/SetComunidad"
        editApiUrl="/api/Comunidades/EditComunidad"
        deleteApiUrl="/api/Comunidades/DeleteComunidad"
        userCodAcceso={Number(user.codAcceso)}
        userCodPerfil={Number(user.role)}
      />
    </PageLayout>
  );
}
